/**
 * Address API-to-Client Adapter
 * 
 * Transforms AddressDto from API into simplified ClientAddress
 */

import { AddressDto } from "../../../../../api-client";
import { ClientAddress } from "../types";

/**
 * Transform API AddressDto to simplified ClientAddress
 */
export const adaptAddressFromApi = (address: AddressDto): ClientAddress => {
  // Address data is nested in contactInfo
  const contactInfo = address.contactInfo;
  const street = contactInfo?.addressLine1 || '';
  const city = contactInfo?.city || '';
  const postalCode = contactInfo?.zip || '';
  const businessName = contactInfo?.businessName || undefined;
  const sublocalityId = address?.sublocalityId; 
  const sublocality = address?.sublocality; 
  
  const parts = [street, postalCode, city].filter(Boolean);
  
  return {
    id: address.id,
    street,
    city,
    postalCode,
    fullAddress: parts.join(', '),
    businessName,
    sublocalityId: sublocalityId,  
    sublocality: sublocality       
  };
};